/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsContainerFindingsCategoryQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsContainerFindingsCategoryQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsContainerFindingsCategoryQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsContainerFindingsCategoryQueryOperator>): AppSecopsContainerFindingsCategoryQueryOperator {
        let obj = Object.assign(new AppSecopsContainerFindingsCategoryQueryOperator(), model);
        AppSecopsContainerFindingsCategoryQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsContainerFindingsCategoryQueryOperator>): AppSecopsContainerFindingsCategoryQueryOperator {
        if (!model) return null;
        return AppSecopsContainerFindingsCategoryQueryOperator.newInstance(<AppSecopsContainerFindingsCategoryQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsContainerFindingsCategoryQueryOperator) {
        if (!obj) return;

        models.AppSecopsContainerFindingsCategoryQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsContainerFindingsCategoryQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsContainerFindingsCategoryQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Finding category to include
     */
    categories: Array<models.SecurityFindingsCategory>;

}
